import React from "react";
import "./TeamLogo.css";

function teamInitials(name) {
  if (!name) return "?";
  const parts = String(name)
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
}

/**
 * Circular team crest. Uses logo_url when present, otherwise initials.
 */
function TeamLogo({ name, logoUrl, size = "md", className = "" }) {
  const classes = ["team-logo", `team-logo--${size}`, className]
    .filter(Boolean)
    .join(" ");

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={name || ""}
        className={classes}
        loading="lazy"
      />
    );
  }

  return (
    <span className={`${classes} team-logo--placeholder`} aria-hidden={!name}>
      {teamInitials(name)}
    </span>
  );
}

export default TeamLogo;
export { teamInitials };
